/**
 * Set some global, reusable widths
 */
const $ = require('jquery');

module.exports = {
  menuBreakpoint: 1000,
};
